import { Config } from "./config";

const GeoLocationResource = {
    base: "/api/country",
    get(id, callback) {
        Config.Connection()
            .get(`${this.base}/${id}`)
            .then(r => callback(r.data))
            .catch(e => callback(e.response?.data));
    },
    find(params, callback) {
        Config.Connection()
            .post(`${this.base}/find`, params)
            .then(r => callback(r.data))
            .catch(e => callback(e.response?.data));
    },
    create(data, callback) {
        Config.Connection()
            .post(this.base, data)
            .then(r => callback(r.data))
            .catch(e => callback(e.response?.data));
    },
    update(data, callback) {
        Config.Connection()
            .put(this.base, data)
            .then(r => callback(r.data))
            .catch(e => callback(e.response?.data));
    },
    timezone(callback) {
        Config.Connection()
            .get(`${this.base}/timezones`)
            .then(r => callback(r.data))
            .catch(e => callback(e.response?.data));
    },
};

export default GeoLocationResource